import BaseRepository from '@/api/repositories/BaseRepository';

class PaymentRepository extends BaseRepository {
	get endpoint() {
		return 'api';
	}
	
	getSalesProducts() {
		return this.get('sales-products');
	}

	getMe() {
		return this.get('subscription/me');
	}

	checkout(data) {
		return this.post('subscription/checkout', data);
	}

	portal(data) {
		return this.get('subscription/portal');
	}


	getSubscriptions() {
		return this.get('subscriptions');
	}

	getPaymentMethods() {
		return this.get('payment-methods');
	}

	createSubscription(data) {
		return this.post('create-subscription', data);
	}

	createSetupIntent(data) {
		return this.post('subscription/intent', data);
	}

	retryPayment(data) {
		return this.post('retry-payment', data);
	}

	getSubscriptionDetails(id) {
		return this.get(`subscriptions/${id}`);
	}
}

export default new PaymentRepository();
